import { jsxs as o, jsx as e } from "react/jsx-runtime";
import { getMainIconProps as t } from "./index.es2361.js";
const p = (d) => {
  const { outline: i, fill: n, size: l } = t(d);
  return /* @__PURE__ */ o(
    "svg",
    {
      width: l,
      height: l,
      viewBox: "0 0 18 18",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ e(
          "path",
          {
            shapeRendering: "optimizeQuality",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M6.065 14.8669L2.133 10.9349L10.935 2.13391L14.866 6.06591L6.065 14.8669Z",
            fill: n
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            shapeRendering: "optimizeQuality",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M5.77531 10.6946L8.44431 8.02561L8.97464 8.55594L6.30564 11.2249L5.77531 10.6946Z",
            fill: i
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            shapeRendering: "optimizeQuality",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M2.22791 10.5721C2.42827 10.6245 2.54821 10.8294 2.49579 11.0298L1.26494 15.7349L5.9701 14.5041C6.17046 14.4516 6.37538 14.5716 6.42779 14.7719C6.48021 14.9723 6.36027 15.1772 6.1599 15.2296L0.834905 16.6226C0.706061 16.6563 0.569007 16.6192 0.474835 16.525C0.380663 16.4308 0.343503 16.2938 0.377208 16.1649L1.77021 10.8399C1.82262 10.6396 2.02754 10.5196 2.22791 10.5721Z",
            fill: i
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            shapeRendering: "optimizeQuality",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13.5488 0.933075C13.3055 0.689163 12.9102 0.688674 12.6655 0.933415L11.1085 2.49042C10.962 2.63686 10.7246 2.63686 10.5781 2.49042C10.4317 2.34397 10.4317 2.10653 10.5781 1.96008L12.1351 0.403085C12.6723 -0.134102 13.5429 -0.134663 14.0796 0.403209L16.5974 2.92003C17.1334 3.4574 17.1338 4.32771 16.5978 4.86508L15.0405 6.42241C14.894 6.56886 14.6566 6.56886 14.5101 6.42241C14.3637 6.27597 14.3637 6.03853 14.5101 5.89209L16.0668 4.33542C16.3107 4.09085 16.3108 3.69488 16.067 3.45026L13.5488 0.933075Z",
            fill: i
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            shapeRendering: "optimizeQuality",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M10.935 1.75885C11.0345 1.75886 11.1299 1.79838 11.2002 1.86872L15.1312 5.80072C15.2776 5.94717 15.2776 6.18458 15.1312 6.33102L6.33016 15.132C6.25984 15.2023 6.16446 15.2418 6.065 15.2418C5.96554 15.2418 5.87016 15.2023 5.79983 15.132L1.86783 11.2C1.79751 11.1297 1.758 11.0343 1.758 10.9348C1.758 10.8354 1.79752 10.74 1.86785 10.6697L10.6698 1.86867C10.7402 1.79834 10.8356 1.75884 10.935 1.75885ZM2.66335 10.9349L6.065 14.3365L14.3357 6.06582L10.935 2.6642L2.66335 10.9349Z",
            fill: i
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            shapeRendering: "optimizeQuality",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M0 17.125H17V17.875H0V17.125Z",
            fill: i
          }
        )
      ]
    }
  );
};
p.__tags = [];
export {
  p as EditIcon
};
//# sourceMappingURL=index.es266.js.map
